import React from 'react';

import { useFormikContext } from 'formik';

import { DisplayUnitConfig } from '@models/PlotConfigs';
import { DisplayUnitOptions } from '@models/PlotDisplayOption';

import SimpleSelectField from './SimpleSelectField';

const DisplayUnitsSelectField = () => {
    const { values, handleChange } = useFormikContext<DisplayUnitConfig>();

    return (
        <div className="form-field">
            <SimpleSelectField
                name="display_units"
                label="Display unit"
                placeholder="Select a value..."
                value={values.display_units}
                onChange={handleChange}
                items={DisplayUnitOptions}
            />
        </div>
    );
};

export default DisplayUnitsSelectField;
